// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-28NCF";
var _4 = "email-1PyMf";
var _5 = "phone__input-3Knva";
var _6 = "email__input-1ijF8";
var _7 = "button-kz0AO";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "email", _5 as "phone__input", _6 as "email__input", _7 as "button" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "email": _4, "phone__input": _5, "email__input": _6, "button": _7 }
